let PackagesItem = [
    {
        id: 1,
        trackTitle: "Senior Level 🔥",
        trackSubtitle: "for experienced Data Science Developers",
        trackPrice: "$49",
        trackDesc: "1",
        trackButton: "Register",
        trackFull: 'On-demand recordings of the event',
        trackLink: 'https://geekle.us/ticket/1655888109935x568784203736416260',
    },
    {
        id: 2,
        trackTitle: "Junior Level",
        trackSubtitle: "for Data Science Developers",
        trackPrice: "FREE",
        trackButton: "Register",
        trackQA: 'Q&A of the Junior Level',
        trackLink: 'https://geekle.us/ticketfree/1655888168062x234721262644494340',
    },
];

export default PackagesItem;
